import {resourceData} from "queries"

export const shopQuery = `query {
  entries: entries(section: "resource", relatedTo: [19923]) {
    ${resourceData}
  }
}`
